import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

@Injectable()
export class AddApiUrlInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    console.log(`${environment.apiUrl}${req.url}`);
    const finalReq = req.url.startsWith('http') ? req : req.clone({ url: `${environment.apiUrl}${req.url}` });
    return next.handle(finalReq);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/add-api-url.interceptor.ts